<div class="vehicles-detail-cards" style="padding-top: 32px;" *ngIf="model != null">
  <div class="medium medium-text vehicles-model vehicles"><span class="vehicle-length">Vehicles ({{model?.length}})</span>
    <div class="vehicles-main">
          <span class="open-enclosed">Open/Enclosed:</span>
          <span class="vehicles-open-enclosed">
            <dynamic-value [type]="'lookup'" [value]="openEnclosed" [items]="lookups.openEnclosed"></dynamic-value>
          </span>
    </div>
  </div>
  <div style="border-bottom: 1px solid #B4B4B4; padding-top:10px; margin-bottom: 10px;"></div>
  <div class="vehicles-cards">
    <table class="detail-table">
      <th id="vehicles-detail-additionalInfo" class="th-display-none"></th>
      <tbody>
        <ng-container *ngFor="let v of model; let i = index">
          <tr>
            <td colspan="2" class="bold" style="margin-bottom: 10px;">Vehicle {{i + 1}}</td>
          </tr>
          <tr>
            <!-- <td class="indent">VIN, Year, Make, Model:</td> -->
            <td>
              <dynamic-value [type]="'text'" [value]="v.year"></dynamic-value>&nbsp;<dynamic-value [type]="'text'"
                [value]="v.make"></dynamic-value>&nbsp;<dynamic-value [type]="'text'" [value]="v.model"></dynamic-value>,
                &nbsp;<dynamic-value [type]="'text'" [value]="v.vin">,&nbsp;</dynamic-value>,&nbsp;<dynamic-value [type]="'lookup'" [value]="v.operability" [items]="lookups.operability"></dynamic-value>
                <div class="mt-1">
                 <span class="align-top mr-2">Additional Info:</span> <dynamic-value [type]="'textarea'" [value]="v.additionalInfo || '-'"></dynamic-value>
                </div>
            </td>
            <!-- <td>
              <dynamic-value [type]="'text'" [value]="v.vin"></dynamic-value>,&nbsp;<dynamic-value [type]="'text'"
                [value]="v.year"></dynamic-value>,&nbsp;<dynamic-value [type]="'text'" [value]="v.make"></dynamic-value>
              ,&nbsp;<dynamic-value [type]="'text'" [value]="v.model"></dynamic-value>
            </td> -->
          </tr>
          <!-- <tr>
            <td class="indent">Operable/Inoperable and Additional Info:</td>
            <td>
              <dynamic-value [type]="'lookup'" [value]="v.operability" [items]="lookups.operability"></dynamic-value>,
              <dynamic-value [type]="'text'" [value]="v.additionalInfo"></dynamic-value>
            </td>
          </tr> -->
        </ng-container>
      </tbody>
    </table>
  </div>
</div>
